<div class="modal-header">
  <i class="material-icons text-secondary me-2" style="font-size: 20px;">inventory_2</i>
  <h4 class="modal-title">
    @if (inventory) {
      Editar inventario
    }

    @if (!inventory) {
      Nuevo inventario
    }
  </h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="activeModal.dismiss('Cross click')">
  </button>
</div>

<div class="modal-body">
  <p class="text-muted small mb-3">Los inventarios son las ubicaciones físicas donde guardas los items que vas a vender.</p>
  @if (!loading) {
    <form
      id="formInventory"
      [formGroup]="formInventory"
      (ngSubmit)="onSubmit()">
      <div class="container-fluid">
        <div class="row">

          @for (key of utilService.objectKeys(dataForm); track key) {

            @if (dataForm[key].type === 'text') {
              <div class="col-12 form-group mb-4">
                <label [htmlFor]="key" class="form-label">
                  {{ dataForm[key].label }}
                </label>
                <input
                  [id]="key"
                  [type]="dataForm[key].type"
                  class="form-control"
                  formControlName="{{ key }}"
                  [placeholder]="dataForm[key].placeholder ?? dataForm[key].label"
                  [ngClass]="{
                    'is-invalid': submitted && f[key].errors
                  }">
                @if (submitted && f[key].errors && dataForm[key].required) {
                  <div class="invalid-feedback">
                    @if (f[key].errors!['required']) {
                      <div>{{ dataForm[key].requiredMessage }}</div>
                    }
                  </div>
                }
              </div>
            }

          }
        </div>
      </div>
    </form>
  }
</div>

<div class="modal-footer d-flex justify-content-end gap-2">
  <button
    (click)="activeModal.close()"
    type="button"
    class="btn btn-outline-secondary">
    Cancelar
  </button>
  <button
    type="submit"
    form="formInventory"
    class="btn btn-primary">
    {{ inventory ? 'Actualizar' : 'Registrar' }}
  </button>
</div>
